module.exports = __webpack_public_path__ + "static/media/business.6fbe1b46.jpg";